import { render, staticRenderFns } from "./Listado.vue?vue&type=template&id=283761a6&scoped=true&"
import script from "./Listado.vue?vue&type=script&lang=js&"
export * from "./Listado.vue?vue&type=script&lang=js&"
import style0 from "./Listado.vue?vue&type=style&index=0&id=283761a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283761a6",
  null
  
)

export default component.exports